import { render } from "./EditInvoiceProject.vue?vue&type=template&id=2e1db406&scoped=true&ts=true"
import script from "./EditInvoiceProject.vue?vue&type=script&lang=ts"
export * from "./EditInvoiceProject.vue?vue&type=script&lang=ts"

import "./EditInvoiceProject.vue?vue&type=style&index=0&id=2e1db406&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1db406"]])

export default __exports__